var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "error-main" }, [
    _c("div", { staticStyle: { "font-size": "35px", "font-weight": "bold" } }, [
      _vm._v("Network Error"),
    ]),
    _vm._v(" "),
    _vm.onLine
      ? _c(
          "div",
          { staticStyle: { "font-size": "18px", "margin-top": "10px" } },
          [_vm._v("\n    大事不妙啦！\n  ")]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticStyle: { "font-size": "16px", "margin-top": "10px" } }, [
      _vm.onLine
        ? _c("div", [
            _c("div", [_vm._v("连接服务器失败，请检查机器联网状态！")]),
            _vm._v(" "),
            _c("div", [_vm._v("如机器正常联网，请联系该网站管理员！")]),
          ])
        : _c("div", [_vm._v("机器未联网，请检查你的网络！")]),
    ]),
    _vm._v(" "),
    _c("div", { staticStyle: { "font-size": "18px", "margin-top": "10px" } }, [
      _c("a", { on: { click: _vm.refreshPage } }, [_vm._v("刷新试试 >")]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }